/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import jwt_decode from "jwt-decode";
import axios from "axios";
import Select from 'react-select';
import config from "../../config/config";
import DynamicEditableTable from "./DynamicEditableTable/DynamicEditableTable";
import Button from "react-bootstrap/Button";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../constants';
import styles from "./AdminPageComp.module.css";
import './AdminPageComp.css';
import UserForm from "./UserForm";

const { API_BASE_URL } = config;

const AdminPageComp = () => {

  const UserToken = keycloak.token;
  let username = "";
  let Email = "";
  if (UserToken) {
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username;
    Email = decoded.email;
  } else {
    console.log("UserToken is null or undefined");
  }

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const { showPopup } = usePopupManager();
  const [data, setData] = useState([]);
  const [showUserForm, setShowUserForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setcurrentPage] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pendingDeleteUserId, setPendingDeleteUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const itemsPerPage = 10;

  const columnDefinitions = [
    { header: "User ID", accessor: "userName" },
    { header: "First Name", accessor: "fname" },
    { header: "Last Name", accessor: "lname" },
    { header: "Email", accessor: "email" },
    { header: "Entity", accessor: "entity" },
    { header: "Level", accessor: "level" },
    { header: "Categories", accessor: "categories" },
    { header: "subCategories", accessor: "subCategories" },
    { header: "Pages", accessor: "pages" },
    { header: "Created On", accessor: "created_at" },
    { header: "Updated On", accessor: "updated_at" },
    { header: "Is Active", accessor: "is_active" },
  ];

  const getUserList = (page = 1) => {
    const config = {
      method: "post",
      url: `${API_BASE_URL}/api/user-list`,
      headers: {
        // Authorization: `Bearer ${token}`,
        Authorization: 'Basic YWRtaW4xOjEyMw==',
        "Content-Type": "application/json",
      },
      data: {
        page: page,
        page_size: itemsPerPage,
      }
    };
    axios
      .request(config)
      .then((response) => {
        setcurrentPage(page);
        setTotalRecords(response.data.count);
        setData(response.data.results);
      })
      .catch((error) => {
        console.error("Error fetching user list:", error);
      });
  };

  useEffect(() => {
    if (token) {
      // console.log("Token is ready:", token);
      getUserList();
    }
  }, [token]);

  const openEditForm = (row) => {
    setEditingUser(row);
    setShowUserForm(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  const handleConfirmDel = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/delete-user-group`,
        { userName:  selectedUser.userName},
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      );
      getUserList();
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "User inactived successfully.",
      });
    } catch (error) {
      console.error("Soft delete failed:", error.response?.data || error.message);
    } finally {
      setShowDeleteModal(false);
      setPendingDeleteUserId(null);
      setSelectedUser(null);
    }
  }

  const handleFormSubmit = async (user) => {
    const isUpdate = !!editingUser;
    if (
      !user.userName?.trim() ||
      !user.fname?.trim() ||
      !user.lname?.trim() ||
      !user.email?.trim() ||
      // !user.entity?.trim() ||
      !Array.isArray(user.entity) || user.entity.length === 0 ||
      !user.level?.trim() ||
      !Array.isArray(user.categories) || user.categories.length === 0 ||
      !Array.isArray(user.subCategories) || user.subCategories.length === 0 ||
      !Array.isArray(user.pages) || user.pages.length === 0
    ) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: `Please fill in all required fields.`,
      });
      return;
    }

    const payload = {
      userName: user.userName,
      is_update: isUpdate,
      fname: user.fname,
      lname: user.lname,
      email: user.email,
      entity: user.entity || [],
      level: user.level,
      categories: user.categories || [],
      subCategories: user.subCategories || [],
      pages: user.pages || [],
      created_by: username,
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/api/create-user-group`, payload, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      });

      const userId = response?.data?.user_id;

      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: `User ${user.userName} Added successfully.`,
      });
      getUserList();
      setShowUserForm(false);
      setEditingUser(null);
    } catch (error) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: `User already exists.`,
      });
      console.error("Error submitting form:", error);
    }
  };

  const handleCancelForm = () => {
    setShowUserForm(false);
    setEditingUser(null);
  };


  // ################### Search Dropdown new code ########################
  const [useridOptions, setUseridOptions] = useState([]);
  const [userid, setUserid] = useState([]);

  const handleUseridChange = (selected) => {
    setUserid(selected);
  };

  const handleSearchUserId = async (inputValue) => {
    if (!inputValue) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/serach-user-id`,
        { searchUserid: inputValue },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            "Content-Type": "application/json",
          },
        }
      );
      setUseridOptions(response.data);
    } catch (error) {
      console.error("Error fetching user IDs:", error);
    }
  };
  
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '55px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };
  
  const handleApply = async () => {
    if (!userid || userid.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `Please select at least one user.`,
      });
      return;
    }
    const selectedIds = userid.map((u) => u.value);
    // console.log("Selected User IDs:", selectedIds);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/user-list`,
        { 
          userIds: selectedIds,
          page: currentPage,
          page_size: 10, 
          },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("Fetched user data:", response.data);
      setTotalRecords(response.data.count);
      setData(response.data.results);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }

  const handleReset = () => {
    setUserid(null);
    getUserList();
  };

  const handleDownloadFile = async () =>{
    let selectedIds = ''
    if (userid !== null){
      selectedIds = userid.map((u) => u.value);
    }
    
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/user-list-download`,
        {
          userIds: selectedIds,
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
            "Content-Type": "application/json",
          },
        }
      );
      const users = response.data;
      const headers = [
        "userName",
        "fname",
        "lname",
        "email",
        "entity",
        "level",
        "categories",
        "subCategories",
        "pages",
        "is_active",
        "created_at",
        "updated_at",
      ];

      const csvRows = [];
      csvRows.push(headers.join(","));
      users.forEach((user) => {
        const row = headers.map((field) => {
          let val = user[field];
          if (val === true) val = "Yes";
          if (val === false) val = "No";
          return `"${val ?? ""}"`;
        });
        csvRows.push(row.join(","));
      });

      const csvData = csvRows.join("\n");
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "users_list_data.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }
  
  // ################### Search Dropdown new code ########################
  return (
    <div className={styles.filter_panel_container}>
      <div className="container m-2">
        {!showUserForm && (
          <div className="row align-items-center">
            <div className="col-md-5 mb-2">
              <h5>Welcome to Command Center Admin Page</h5>
            </div>
            <div className="col-md-3 mb-2">
              <div className={styles.filter_panel_col}>
                <div className={styles.filter_select_wrapper}>
                  <Select
                    value={userid}
                    isMulti= "true"
                    placeholder={<div className="select-placeholder-text">Serach User Id/Name</div>}
                    onChange={handleUseridChange}
                    options={useridOptions}
                    isSearchable={true}
                    onInputChange={(value) => {handleSearchUserId(value);}}
                    styles={customStyles}
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2 mb-2">
              <div className="d-flex gap-2">
                <button onClick={handleApply} className="btn apply-btn w-100">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn w-100">
                  Reset
                </button>
              </div>
            </div>
            <div className="col-md-2 mb-2 d-flex justify-content-center">
              <button
                className="btn w-100"
                style={{
                  background: "#04AA6D",
                  color: "white",
                  fontWeight: "bold",
                  padding: "8px 12px",
                }}
                onClick={() => {
                  setEditingUser(null);
                  setShowUserForm(true);
                }}
              >
                Create New User
              </button>
            </div>
          </div>
        )}
      </div>
      {showUserForm ? (
        <UserForm
          initialData={editingUser}
          onSubmit={handleFormSubmit}
          onCancel={handleCancelForm}
        />
      ) : (
        <DynamicEditableTable
          data={data}
          columns={columnDefinitions}
          onDelete={handleDelete}
          openEditPopup={openEditForm}
          totalRecords={totalRecords}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          onPageChange={getUserList}
          handleDownload={handleDownloadFile}
        />
      )}
      {showDeleteModal && selectedUser && (
        <div className="modal custom-modal fade show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setPendingDeleteUserId(null);
                    setSelectedUser(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete user <strong>{pendingDeleteUserId}</strong>?
                </p>
                {!selectedUser.is_active && (
                  <div className="alert alert-warning mb-0 p-2">User is already inactive.</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setPendingDeleteUserId(null);
                    setSelectedUser(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleConfirmDel}
                >
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPageComp;
